module.exports = __webpack_public_path__ + "media/images/delete-button-a6b94bf0.png";